import { SET_FILTERS, CLEAR_FILTERS, LOGOUT } from "../actions/types";

const initialState = {};

const searchFilters = (state = initialState, action: any) => {
  const { type, payload } = action;

  switch (type) {
    case SET_FILTERS:
      return {...state, filters: payload, count:Object.keys(payload).length };

    case CLEAR_FILTERS:
      return {...state, filters: {}, count: 0, skipDefaultLocation: true };

    // Reset to defaults so the next login re-applies the profile-based default filters.
    case LOGOUT:
      return initialState;

    default:
      return state;
  }
}

export default searchFilters;
